import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=a380d422&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style0 from "./menu.vue?vue&type=style&index=0&id=a380d422&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a380d422",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\sseinfo\\src_finreport_xc\\tdinfo-szs-finreport-pc-\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a380d422')) {
      api.createRecord('a380d422', component.options)
    } else {
      api.reload('a380d422', component.options)
    }
    module.hot.accept("./menu.vue?vue&type=template&id=a380d422&scoped=true", function () {
      api.rerender('a380d422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menu.vue"
export default component.exports